<template>
  <div class="dropdown">
    <treatment-dropdown>
      <template slot="dropdown-icon" slot-scope="{ disableDropdownVisibility }">
        <component
          :is="currentIconComponent"
          tabindex="-1"
          :class="[isAlmaTerritory ? 'alma-color' : 'orange-color']"
          @blur="disableDropdownVisibility"
        />
      </template>
      <template slot="dropdown-options">
        <treatment-product-options :value="usage" :options="options" @select-option="selectOption">
          <template slot="option" slot-scope="{ option }">
            <component
              :is="getIconComponent(option)"
              class="option__content"
              :class="{ 'option__content--active': usage === option }"
            />
          </template>
        </treatment-product-options>
      </template>
    </treatment-dropdown>
  </div>
</template>

<script>
import TreatmentDropdown from '@/modules/dashboard/components/create-treatment-tab/treatments/TreatmentDropdown';
import TreatmentProductOptions from '@/modules/dashboard/components/create-treatment-tab/treatments/TreatmentProductOptions';
import isAlmaTerritories from '@/modules/dashboard/components/mixins/isAlmaTerritories';
import MorningUsage from '@/modules/dashboard/components/icons/MorningUsage.vue';
import MorningAndEveningUsage from '@/modules/dashboard/components/icons/MorningAndEveningUsage.vue';
import EveningUsage from '@/modules/dashboard/components/icons/EveningUsage.vue';

import { TREATMENT_USAGE_ICON_CLASSES } from '@/modules/dashboard/api/constants';

const TREATMENT_USAGE_ICON_COMPONENTS = {
  morningOnly: MorningUsage,
  eveningOnly: EveningUsage,
  morningAndEvening: MorningAndEveningUsage,
  oneMorningOneEvening: MorningAndEveningUsage
};

const USAGE_TO_ICON_CLASS = {
  morningOnly: 'icon-morning-usage',
  eveningOnly: 'icon-evening-usage',
  oneMorningOneEvening: 'icon-morning-and-evening-usage'
};

export default {
  name: 'TimeUsageDropdown',
  components: { TreatmentDropdown, TreatmentProductOptions },
  mixins: [isAlmaTerritories],

  props: {
    usage: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isDropdownVisible: false,
      usageIconClasses: TREATMENT_USAGE_ICON_CLASSES,
      usageIconComponents: TREATMENT_USAGE_ICON_COMPONENTS,
      usageToIconClass: USAGE_TO_ICON_CLASS
    };
  },
  computed: {
    currentIconComponent() {
      return TREATMENT_USAGE_ICON_COMPONENTS[this.usage];
    }
  },
  methods: {
    getIconComponent(option) {
      return TREATMENT_USAGE_ICON_COMPONENTS[option];
    },
    selectOption(usage) {
      this.$emit('select-usage', usage);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/common/text';

.dropdown__icon:focus,
.alma-color:focus,
.orange-color:focus {
  outline: none;
  box-shadow: none;
}
</style>
